module.exports = __webpack_public_path__ + "img/cs8.58caf0f9.png";